'use client'

import type { NavItem } from '@/constants'

import './radio.css'

import { useRouter } from 'next/navigation'

interface PillRadioProps {
  items?: NavItem[]
  setTab?: (tab: number) => void
  active?: number
  setTabDesktopContent?: (items: NavItem[]) => void
}

function PillRadio({ items = [], setTab, active, setTabDesktopContent }: PillRadioProps) {
  const router = useRouter()
  return (
    <div className="pill-radio-container">
      {items.map((item, index) => {
        return (
          <div
            key={index}
            onClick={() => {
              setTab?.(item.id ?? 0)
              setTabDesktopContent?.(item.item ?? [])
              if (item.id === 1) {
                router.push(`/business/treasury/deposit`)
              } else if (item.id === 3) {
                router.push(`/digital-banking-overview`)
              } else if (item.id === 2) {
                router.push(`/about`)
              } else {
                router.push(`/`)
              }
            }}
            className={`item cursor-pointer ${active === item.id ? `active` : ``}`}
          >
            {item.name}
          </div>
        )
      })}
    </div>
  )
}

export default PillRadio
